<template>
  <div id="app" :class="'locale-'+$i18n.locale">
    <loading :open="!DOMloaded" :refresh="refresh" :label="loadingLabel" error="false"></loading>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
//
import loading from './components/loading'
const axios = require('axios')

export default {
  components: {
    loading
  },
  computed: {
    ...mapState(['countries', 'countriesData', 'groups', 'theme']),
    ...mapGetters(['getSelectedCountries'])
  },
  data () {
    return {
      refresh: null,
      DOMloaded: false,
      loadingLabel: 'loading'
    }
  },
  watch: {
    $route (to, from) {
      this.$store.commit('config', to.query)
    },
    theme (to, from) {
      localStorage.theme = to
      if (to === 'dark') {
        document.documentElement.setAttribute('dark', '')
        document.documentElement.removeAttribute('light')
      } else {
        document.documentElement.setAttribute('light', '')
        document.documentElement.removeAttribute('dark')
      }
    }
  },
  created () {
    this.$store.commit('config', this.$route.query)
    console.log('created')
    console.time()
  },
  methods: {
    loadData (hide = false) {
      if (!hide) {
        this.refresh = null
      }
      axios.get('https://corona.lmao.ninja/v2/countries').then((resp) => {
        if (!hide) {
          this.$store.commit('setCountriesData', resp.data)

          // this.$store.commit('setUserData', resp2.data)
          // this.$store.commit('setSelectedCountry', this.$store.getters.getSelectedCountries()[0])
          // var lang = navigator.language || navigator.userLanguage
          // if (lang && lang.includes('ar') && !localStorage.locale && !this.$route.query.locale) {
          //   this.$router.push({ query: { ...this.$route.query, locale: 'ar' } })
          // }
          // this.$store.commit('config', this.$route.query)
          // this.DOMloaded = true
          axios.get('https://api.ipregistry.co/?key=tryout').then((resp2) => {
            console.log('resp2.data')
            console.log(resp2.data)

            this.$store.commit('setUserData', resp2.data)
            this.$store.commit('setSelectedCountry', this.$store.getters.getSelectedCountries().find(_country => _country.country.code === resp2.data.location.country.code))
            if (this.$store.state.groups.all.ARAB.list.includes(resp2.data.country_code) && !this.$route.query.group && !localStorage.group) {
              this.$store.commit('setGroup', this.$store.state.groups.all.ARAB)
            }
            var lang = navigator.language || navigator.userLanguage || resp2.data.location.country.languages[0].code || 'en'
            if (lang && lang.includes('ar') && !localStorage.locale && !this.$route.query.locale) {
              this.$router.push({ query: { ...this.$route.query, locale: 'ar' } })
            }
          }).catch(e => {
            if (!hide) {
              this.refresh = this.loadData
            }
          })
          this.$store.commit('config', this.$route.query)
          this.DOMloaded = true
        } else {
          this.$store.commit('updateCountriesData', resp.data)
        }
      }).catch(e => {
        if (!hide) {
          this.refresh = this.loadData
        }
      })
    }
  },
  mounted () {
    window.addEventListener(
      'resize',
      this.$store.commit('setMedia')
    )
    if (localStorage.theme && !this.$route.query.theme) {
      this.$router.push({ query: { ...this.$route.query, theme: localStorage.theme } })
    }
    if (localStorage.locale && !this.$route.query.locale) {
      this.$router.push({ query: { ...this.$route.query, locale: localStorage.locale } })
    }
    if (this.$store.state.theme === 'dark') {
      document.documentElement.setAttribute('dark', '')
      document.documentElement.removeAttribute('light')
    } else {
      document.documentElement.setAttribute('light', '')
      document.documentElement.removeAttribute('dark')
    }
    this.$watch(
      '$i18n.locale',
      (newLocale, oldLocale) => {
        this.$router.push({ query: { ...this.$route.query, locale: newLocale } })
        localStorage.locale = newLocale
        if (newLocale === 'ar') {
          document.documentElement.setAttribute('rtl', '')
          document.documentElement.removeAttribute('ltr')
        } else {
          document.documentElement.setAttribute('ltr', '')
          document.documentElement.removeAttribute('rtl')
        }
      },
      { immediate: true }
    )
    this.loadData()
    setInterval(() => {
      this.loadData(true)
    }, 60000)
  }
}

</script>
<style lang="scss">
@import "~physia/resources/sass/import.scss";
@import url(https://fonts.googleapis.com/css?family=Product+Sans:400,500,600,700,900);
@import url(https://www.fontstatic.com/f=asmaa);
html {
  font-family: "asmaa","Product Sans";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 20px;
  scroll-behavior: smooth;
}
body {
  --clr-p:rgb(50, 222, 132);
  --clr-s:#1dde99;
  --el-u: 0;--el-p: 0;
}
* {
  scrollbar-width: thin;
  scrollbar-color: var(--theme-colors-15) rgba(0, 128, 0, 0);
}
.locale-en .-en-x {
  transform: scaleX(-1);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.font-ar {
font-family: 'asmaa'
}
.font-en {
font-family: 'Product Sans'
}
.show-grid * {
  outline: 1px solid deeppink;
}

.show-padding * {
  background-image: linear-gradient(
      to bottom,
      rgb(255, 255, 255) 0%,
      rgb(255, 255, 255) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 203, 0, 0.25) 0%,
      rgba(255, 203, 0, 0.25) 100%
    );
  background-clip: content-box, padding-box;
}
</style>
